exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bZG4BNwyMxVswpLLxC8LK {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "bZG4BNwyMxVswpLLxC8LK"
};